import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import eye from '../../assets/images/icons/eye.svg';
import eyeOff from '../../assets/images/icons/eye-off.svg'
import '../../assets/css/ChangePassword.css';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const ChangePassword = () => {

    const [showWritePass, setShowWritePass] = useState(false)
    const [showRewritePass, setShowRewritePass] = useState(false)
    const [pass, setPass] = useState("")
    const [confirmPass, setConfirmPass] = useState("")
    const [token, setToken] = useState("")
    const [email, setEmail] = useState("")
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        if (location) {
            setEmail(location?.state?.email)
            setToken(location?.state?.token)
        }
    }, [])

    const handleSubmit = async (e) => {

        e.preventDefault()
        if (token) {
            if (pass === confirmPass) {
                const obj = {
                    token,
                    password: pass,
                }
                new WebApiCalls().updatePassword(token, obj)
                    .then(res => {
                        if (res?.code == 200) {
                            toast.success(res?.data?.desc)
                            navigate("/login")
                        }
                    })
                    .catch(err => { })
            }
            else {
                toast.error("Oops...! Password miss-matched...")
            }
        }


    }

    return (
        <Container fluid>
            <Row className="justify-content-center align-items-center">
                {/* Image section */}
                <Col className="px-0">
                    <div className="forget-bg3">
                        <div className="f-header">
                            <p>Transit</p>
                            <p>Rewards for</p>
                            <span>Canadians</span>
                        </div>
                    </div>
                </Col>
                {/* Input Section */}
                <Col>
                    <div className="forget-pass-wrapper mx-auto w-50">
                        <Form onSubmit={handleSubmit}>
                            <div className="forget-title mb-5">
                                <p>
                                    Please Change Your
                                    <br />
                                    <strong>Password!</strong>
                                </p>
                            </div>
                            <div className="mb-5">

                                <Form.Group className="mb-3 group-1  shadow-none d-flex" controlId="email">
                                    <Form.Control className="change-pass-mail" type={showWritePass ? "text" : "password"} placeholder="Create New Password" value={pass}
                                        onChange={e => setPass(e.target.value)} required />
                                    <Image className='eye-image' src={showWritePass ? eyeOff : eye} onClick={() => setShowWritePass(s => !s)} />
                                </Form.Group>

                                <Form.Group className="mb-3 group-2 shadow-none d-flex" controlId="email">
                                    <Form.Control className="change-pass-mail" type={showRewritePass ? "text" : "password"} placeholder="Re-enter New Password"
                                        value={confirmPass} onChange={e => setConfirmPass(e.target.value)} required />
                                    <Image className='eye-image' src={showRewritePass ? eyeOff : eye} onClick={() => setShowRewritePass(s => !s)} />
                                </Form.Group>
                            </div>
                            {/* Send Button */}
                            <div className="text-center">
                                <Button type="submit" bsPrefix="code-btn" size="lg">
                                    SAVE PASSWORD
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default ChangePassword;
